export default "0c38374396acae31.svg"